import companyLogo from 'assets/funnel/power_serv.jpg';
import aiDisclaimer from 'assets/funnel/ai-disclaimer.png';
import handshakeImg from 'assets/funnel/hand_shake_lkw.png';

import lackiererLandingHero from 'assets/funnel/lackier_start.png';
import lackiererHero from 'assets/funnel/lackier_main.png';
import lackiererGroup from 'assets/funnel/lackier_group.png';
import lackiererJobDetails from 'assets/funnel/lackier_job_details.png';

const FUNNEL_CONFIGS = {
  lackierer: {
    documentTitle: "Lackierer:in (m/w/d) | POWERSERV Austria GmbH",
    companyLogo,
    companyName: "POWERSERV Austria GmbH",
    aiDisclaimer,

    landing: {
      heroImg: lackiererLandingHero,
      chipText: "Farbe bekennen.",
      heroTitle: "Lackierer:in (m/w/d) · Vollzeit",
      heroSubtitle: "Wir suchen dich! Verstärke das Team unseres Kunden in der Schienenfahrzeugtechnik.",
      facts: [
        { icon: 'bi-clock',         title: '38,5 Std. / Woche',       subtitle: '2-Schichtbetrieb 06:00 – 22:00 Uhr' },
        { icon: 'bi-cash-stack',    title: '€ 3.058,– + Überstunden', subtitle: 'voll ausbezahlt – kein Zeitausgleich' },
        { icon: 'bi-calendar-check',title: 'Start: ehestmöglich',     subtitle: 'langfristiger Einsatz' },
        { icon: 'bi-geo-alt-fill',  title: '1110 Wien',               subtitle: 'Öffentlich erreichbar' },
      ],
    },

    info: {
      heroImg: lackiererHero,
      heroChip: "Vollzeit · Schienenfahrzeugtechnik",
      heroTitleLines: ["Lackierer:in", "(m/w/d)"],
      facts: [
        { value: "€ 3.058", label: "Monatslohn + Überstunden" },
        { value: "38,5 h",  label: "geregelte Woche" },
      ],
      moechtestDuItems: [
        { icon: 'bi-brush',       text: 'dein Handwerk als Lackierer:in in einem international erfolgreichen Unternehmen der Schienenfahrzeugtechnik einsetzen?' },
        { icon: 'bi-train-front', text: 'an beeindruckenden Projekten arbeiten und Züge sowie Waggone mit hochwertigen Mehrschichtlackierungen veredeln?' },
        { icon: 'bi-award',       text: 'langfristig in einem stabilen Betrieb mit echter Übernahmemöglichkeit durch unseren Kunden tätig sein?' },
      ],
      benefits: [
        { icon: 'bi-clock',        title: '38,5-Stunden-Woche',    desc: 'Geregelter 2-Schichtbetrieb zwischen 06:00 und 22:00 Uhr.' },
        { icon: 'bi-cash-stack',   title: '€ 3.058,– Monatslohn',  desc: 'Überstunden werden vollständig ausbezahlt – kein Zeitausgleichskonto.' },
        { icon: 'bi-person-check', title: 'Echte Übernahmechance', desc: 'Langfristige Perspektive mit Übernahmemöglichkeit durch unseren Kunden.' },
        { icon: 'bi-layers',       title: 'Abwechslungsreiche Arbeit', desc: 'Von Schleifen und Kitten bis zur 7-Schicht-Lackierung – kein Tag wie der andere.' },
        { icon: 'bi-geo-alt-fill', title: '1110 Wien',             desc: 'Öffentlich erreichbar.' },
        { icon: 'bi-building',     title: 'Internationaler Betrieb', desc: 'Führender Anbieter für Instandhaltung und Weiterentwicklung von Schienenfahrzeugen.' },
      ],
      tasks: [
        'Lackieren von Zügen und Waggonen',
        'Schleifen und Kitten von Zugoberflächen',
        'Arbeiten mit Lackpistolen',
        'Mehrschichtlackierung (7 Schichten)',
      ],
      requirements: [
        'Abgeschlossene Berufsausbildung mit LAP als Lackierer oder Karosseriebautechniker (m/w/d)',
        'Mindestens 2 Jahre Berufserfahrung als Lackierer',
        'Deutschkenntnisse mindestens B2',
        'Selbstständige Arbeitsweise',
        'Teamfähigkeit und Verlässlichkeit',
        'Einwandfreier Leumund',
        'Überstundenbereitschaft auch am Samstag',
        'Bereitschaft für 2-Schichtbetrieb (06:00 – 22:00 Uhr)',
      ],
      jobDetailsImg: lackiererJobDetails,
      jobDetailsTagLines: ["Präzision in", "7 Schichten"],
      noteText: "Eine spannende, herausfordernde und abwechslungsreiche Position – jeder Waggon ist ein sichtbares Ergebnis deiner Arbeit.",
      groupImg: lackiererGroup,
      companyDescription: "Wir bei POWERSERV Austria stellen Menschen in den Mittelpunkt – Bewerber:innen, Mitarbeiter:innen und Kund:innen. Unser Anspruch ist es, durch Qualität, persönliche Betreuung und Engagement die besten Lösungen in der Personaldienstleistung zu bieten. Als zugelassene Personalvermittlerin setzen wir auf nachhaltiges Wachstum, langjährige Partnerschaften und entwickeln uns laufend im Einklang mit den Markttrends weiter. Unsere Vision: arbeitssuchenden Menschen die passenden Karrieremöglichkeiten eröffnen und Unternehmen mit den richtigen Mitarbeiter:innen zusammenbringen.",
      finalCtaTitle: "Dann bist du bei uns genau richtig!",
      finalCtaText: "Beantworte ein paar kurze Fragen – ganz ohne Lebenslauf und Anschreiben. Wir melden uns bei dir.",
    },

    quiz: {
      handshakeImg,
    },
  },
};

export const DEFAULT_FUNNEL_TYPE = 'lackierer';
export default FUNNEL_CONFIGS;
